/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_D3dInputs */

const en_mk_sol_konsultan_d3d = /** @type {(inputs: Mk_Sol_Konsultan_D3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The run transcript shows which documents were read, so a citation can be verified before it enters the report.`)
};

const id_mk_sol_konsultan_d3d = /** @type {(inputs: Mk_Sol_Konsultan_D3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkrip run menunjukkan dokumen mana yang dibaca, jadi kutipan bisa diverifikasi sebelum masuk laporan.`)
};

/**
* | output |
* | --- |
* | "The run transcript shows which documents were read, so a citation can be verified before it enters the report." |
*
* @param {Mk_Sol_Konsultan_D3dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_d3d = /** @type {((inputs?: Mk_Sol_Konsultan_D3dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_D3dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_d3d(inputs)
	return en_mk_sol_konsultan_d3d(inputs)
});